import React, {useState, createContext} from 'react';

const EasyDetectContext = createContext(null);

function EasyDetectContextProvider({children}) {
  const [isAggregateFunction, setIsAggregateFunction] = useState(false);
  const [aggregateFunction, setAggregateFunction] = useState('last_30m');

  return (
    <EasyDetectContext.Provider
      value={{
        isAggregateFunction,
        setIsAggregateFunction,
        aggregateFunction,
        setAggregateFunction,
      }}
    >
      {children}
    </EasyDetectContext.Provider>
  );
}

export {EasyDetectContext, EasyDetectContextProvider};
